// 左側「製單」底下的二級選單:全部 / 已結案 / 未結案(業主 2026-11-02)。
//
// 已結案 = 已完成;未結案 = 草稿、待覆核、已覆核、已寄出;已作廢只在「全部」看得到。
// 實際怎麼篩是後端的 `view`(app/routers/work_orders.py 的 VIEWS),這裡只記選了哪一個。
// 記在這台瀏覽器(localStorage),側邊欄與列表靠 `WORK_ORDER_VIEW_CHANGED` 事件對齊。

export type WorkOrderView = "ALL" | "CLOSED" | "OPEN";

export const WORK_ORDER_VIEWS: { key: WorkOrderView; label: string }[] = [
  { key: "ALL", label: "全部" },
  { key: "CLOSED", label: "已結案" },
  { key: "OPEN", label: "未結案" },
];

const STORAGE_KEY = "nebula.workorders.view";
export const WORK_ORDER_VIEW_CHANGED = "work-order-view-changed";

export function loadWorkOrderView(): WorkOrderView {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    return saved === "CLOSED" || saved === "OPEN" ? saved : "ALL";
  } catch {
    return "ALL";
  }
}

export function saveWorkOrderView(view: WorkOrderView): void {
  try {
    localStorage.setItem(STORAGE_KEY, view);
  } catch {
    // 存不了(隱私模式)就只換這一次
  }
  window.dispatchEvent(new CustomEvent<WorkOrderView>(WORK_ORDER_VIEW_CHANGED, { detail: view }));
}

/** 目前選的分類,另一個元件換了也跟著換。 */
export function subscribeWorkOrderView(onChange: (view: WorkOrderView) => void): () => void {
  const handler = (event: Event) => onChange((event as CustomEvent<WorkOrderView>).detail ?? "ALL");
  window.addEventListener(WORK_ORDER_VIEW_CHANGED, handler);
  return () => window.removeEventListener(WORK_ORDER_VIEW_CHANGED, handler);
}
